/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_DemoteInputs */

const cs_property_ai_demote = /** @type {(inputs: Property_Ai_DemoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přesunout do AI návrhů`)
};

const en_property_ai_demote = /** @type {(inputs: Property_Ai_DemoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move to AI drafts`)
};

/**
* | output |
* | --- |
* | "Move to AI drafts" |
*
* @param {Property_Ai_DemoteInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_demote = /** @type {((inputs?: Property_Ai_DemoteInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_DemoteInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_demote(inputs)
	return cs_property_ai_demote(inputs)
});